import * as React from "react";
import { forwardRef } from "react";
const SvgOval = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" ref={ref} {...props}><defs><linearGradient id="prefix__a" x1="3.772%" x2="89.946%" y1="0%" y2="100%"><stop offset="0%" stopColor="#FF9E55" /><stop offset="100%" stopColor="#AE5F00" /></linearGradient></defs><circle cx={7} cy={8.5} r={7} fill="url(#prefix__a)" fillRule="evenodd" transform="translate(0 -1.5)" /></svg>;
const ForwardRef = forwardRef(SvgOval);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/orak_Connect_service_dev_develop/src/images/oval.svg?url";
export default __svgUrl;
